module.exports = __webpack_public_path__ + "static/img/total_user.6b38b2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/total_user.png
// module id = IuW9
// module chunks = 0